import { CotacoesLista } from "#/types";
import dayjs from "dayjs";

export const MOCK_LISTA_COTACOES: CotacoesLista[] = [
  {
    numero: "0155020202202500000008",
    dataExpiracao: dayjs().add(3, "day").format("YYYY-MM-DD"),
    descricao: "Veiculo XYZ",
    status: "ATIVA",
  },
  {
    numero: "0155020202202500000007",
    dataExpiracao: dayjs().add(3, "day").format("YYYY-MM-DD"),
    status: "ATIVA",
  },
  {
    numero: "0155020202202500000006",
    dataExpiracao: dayjs().add(3, "day").format("YYYY-MM-DD"),
    placa: "AAA1111",
    status: "ATIVA",
  },
  {
    numero: "0155020202202500000005",
    dataExpiracao: dayjs().add(3, "day").format("YYYY-MM-DD"),
    chassi: "9BD99439XG9153469",
    status: "ATIVA",
  },
  {
    numero: "0155020202202500000004",
    dataExpiracao: dayjs().add(3, "day").format("YYYY-MM-DD"),
    descricao: "COROLLA XEI 2.0 FLEX 16V AUT. (GAS.)",
    status: "ATIVA",
  },
  {
    numero: "0155020202202500000003",
    dataExpiracao: dayjs().add(5, "day").format("YYYY-MM-DD"),
    descricao: "Veiculo XYZ",
    status: "ATIVA",
  },
  {
    numero: "0155020202202500000002",
    dataExpiracao: dayjs().add(6, "day").format("YYYY-MM-DD"),
    descricao: "Veiculo XYZ",
    status: "ATIVA",
  },
  {
    numero: "0155020202202500000001",
    dataExpiracao: "2025-05-13",
    descricao: "Veiculo XYZ",
    status: "EXPIRADA",
  },
];
